"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringEditor = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
function StringEditor(_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange;
    return (react_1.default.createElement(material_1.TextField, { sx: {
            '& .MuiInputBase-root': {
                flex: 1,
            },
        }, label: label, margin: "dense", fullWidth: true, style: { flex: 1 }, InputLabelProps: { shrink: true }, inputProps: { style: { height: '100%', overflow: 'auto' } }, hiddenLabel: true, autoCorrect: "off", spellCheck: "false", autoComplete: "off", multiline: true, variant: "outlined", value: value, onChange: function (e) { return onChange(e.target.value); } }));
}
exports.StringEditor = StringEditor;
